import { createSlice } from "@reduxjs/toolkit";


const promoterNameSlice = createSlice({
    name :"promotername",
    initialState: {
        name : "",
    },
    reducers:{
        changename(state,action){
            state.name = action.payload
        }

    }
}) 

export const promoterNameActions = promoterNameSlice.actions;

export default promoterNameSlice